import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import { SearchEnum } from '../../../../common/enums/search.enum';
import { Meta } from '../../../../common/models/api-response.model';
import {
  PositionDetail,
  PositionListItem,
  PositionWritePayload,
} from './position.model';

@Injectable({ providedIn: 'root' })
export class PositionService {
  private readonly http = inject(HttpClient);
  private readonly endpoints = ENDPOINTS.Dashboard.Positions;

  getPositionList(
    page: number,
    perPage: number,
    sort?: { key: string; value: 'asc' | 'desc' },
    filter?: string,
    search?: string
  ) {
    let params = new HttpParams()
      .append('page', page)
      .append('per_page', perPage);
    if (sort?.key) {
      params = params.append(`sort[${sort.key}]`, sort.value);
    }
    if (filter && filter !== 'all') {
      params = params.append('filters[state]', filter);
    }
    if (search) {
      params = params.append(SearchEnum.keyword, search);
    }
    return this.http.get<{ data: PositionListItem[]; meta: Meta }>(
      this.endpoints.List,
      { params }
    );
  }

  getPositionDetails(id: string) {
    return this.http.get<{ data: PositionDetail }>(
      this.endpoints.Details.replace('{id}', id)
    );
  }

  createPosition(payload: PositionWritePayload) {
    return this.http.post(this.endpoints.Create, payload);
  }

  updatePosition(id: string, payload: PositionWritePayload) {
    return this.http.post(this.endpoints.Update.replace('{id}', id), {
      ...payload,
      _method: 'put',
    });
  }

  activatePosition(positionId: string) {
    return this.http.put(
      this.endpoints.Activate.replace('{id}', positionId),
      {}
    );
  }

  deactivatePosition(positionId: string, replacementPositionId: number) {
    return this.http.put(
      this.endpoints.Deactivate.replace('{id}', positionId),
      { replacement_position_id: replacementPositionId }
    );
  }

  deletePosition(positionId: string) {
    return this.http.delete(this.endpoints.Delete.replace('{id}', positionId));
  }
}
